module.exports = __webpack_public_path__ + "img/Jim Hill.433cfa65.jpg";